import { SignInConstants } from "../constants/signin.constants";

const JWTReducer = (state, action) => {
  switch (action.type) {
    case SignInConstants.INITIALIZE:
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        user: action.payload.user,
      };
    case SignInConstants.SIGN_IN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    case SignInConstants.SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };

    case SignInConstants.SIGN_UP:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };

    case SignInConstants.FETCH_MENU_REQUEST:
      return {
        ...state,
        isMenuLoading: true,
        userMenus: [],
      };
    case SignInConstants.FETCH_MENU_SUCCESS:
      return {
        ...state,
        isMenuLoading: false,
        userMenus: action.payload,
      };
    case SignInConstants.FETCH_MENU_FAILURE:
      return {
        ...state,
        isMenuLoading: false,
      };

    case SignInConstants.FETCH_MENU_WITH_ID_REQUEST:
      return {
        ...state,
        isEmpLoading: true,
        employeeMenus: [],
      };
    case SignInConstants.FETCH_MENU_WITH_ID_SUCCESS:
      return {
        ...state,
        isEmpLoading: false,
        employeeMenus: action.payload,
      };
    case SignInConstants.FETCH_MENU_WITH_ID_FAILURE:
      return {
        ...state,
        isEmpLoading: false,
      };

    case SignInConstants.AUTH_USER_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoadingAutoSearch: true,
        hasError: false,
      };
    case SignInConstants.AUTH_USER_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoadingAutoSearch: false,
        authUserAutoSearchResults: action.payload,
      };
    case SignInConstants.AUTH_USER_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingAutoSearch: false,
      };

    default:
      return state;
  }
};

export default JWTReducer;
